import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { LanguageSelector } from './LanguageSelector';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from "react-router-dom";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useLanguage();

  // Logos URLs
  const logoOriginal = "images/logo.webp";
  const logoMinified = "images/logoHatMin.webp";

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 backdrop-blur-md border-b border-gray-200 z-50 transition-all duration-300 ${isScrolled
      ? 'bg-black/70 shadow-lg border-b-primary border-b-2'
      : 'bg-white/95 shadow-sm'
      }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`flex justify-between items-center transition-all duration-300 ${isScrolled ? 'h-14' : 'h-16'
          }`}>
          {/* Logo */}
          <div className="flex items-center">
            <div className="relative">
              <img
                src={isScrolled ? logoMinified : logoOriginal}
                alt="Hack a Tech"
                className={`transition-all duration-500 ease-in-out ${isScrolled ? 'h-12 w-12' : 'h-14 w-auto'
                  }`}
                style={{
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
                  maxWidth: isScrolled ? '48px' : '160px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to={`/`}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-primary hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              Home
            </Link>
            <button
              onClick={() => scrollToSection('sobre')}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-white hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-white hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-white hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              {t('nav.differentials')}
            </button>
            <button
              onClick={() => scrollToSection('blog')}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-white hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              {t('nav.blog')}
            </button>

            {/* Language Selector */}
            <LanguageSelector />

            <Button
              onClick={() => scrollToSection('contato')}
              className="bg-primary hover:bg-primary/90 text-white"
            >
              {t('nav.contact')}
            </Button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <LanguageSelector />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`transition-colors duration-200 ${isScrolled
                ? 'text-white hover:text-primary'
                : 'text-gray-700 hover:text-primary'
                }`}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className={`md:hidden border-t transition-colors duration-300 ${isScrolled
            ? 'border-gray-400/50 bg-gray-600/95'
            : 'border-gray-200 bg-white'
            }`}>
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
              to={`/`}
              className={`block w-full text-left px-3 py-2 transition-colors duration-200 ${isScrolled
                  ? 'text-primary hover:text-primary'
                  : 'text-gray-700 hover:text-primary'
                  }`}
            >
              Home
            </Link>
              <button
                onClick={() => scrollToSection('sobre')}
                className={`block w-full text-left px-3 py-2 transition-colors duration-200 ${isScrolled
                  ? 'text-white hover:text-primary'
                  : 'text-gray-700 hover:text-primary'
                  }`}
              >
                {t('nav.about')}
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className={`block w-full text-left px-3 py-2 transition-colors duration-200 ${isScrolled
                  ? 'text-white hover:text-primary'
                  : 'text-gray-700 hover:text-primary'
                  }`}
              >
                {t('nav.services')}
              </button>
              <button
                onClick={() => scrollToSection('diferenciais')}
                className={`block w-full text-left px-3 py-2 transition-colors duration-200 ${isScrolled
                  ? 'text-white hover:text-primary'
                  : 'text-gray-700 hover:text-primary'
                  }`}
              >
                {t('nav.differentials')}
              </button>
              <button
                onClick={() => scrollToSection('blog')}
                className={`block w-full text-left px-3 py-2 transition-colors duration-200 ${isScrolled
                  ? 'text-white hover:text-primary'
                  : 'text-gray-700 hover:text-primary'
                  }`}
              >
                {t('nav.blog')}
              </button>
              <div className="px-3 py-2">
                <Button
                  onClick={() => scrollToSection('contato')}
                  className="w-full bg-primary hover:bg-primary/90 text-white"
                >
                  {t('nav.contact')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};